import { TStore } from '@/common/basis/types/tstore';
import { TField } from '@/common/basis/types/tfield';

const state: TStore.Booking = {
  isOpenBookingMeeting: false,
  bookingMeetingType: TField.MEETING_TYPE_BOOKING,
  isOpenCannelMeeting: false,
  isOpenBookingDetail: false,
  bookingRoomId: '', // 预约会议的ID
  cancelRoomId: '', // 取消会议ID
  detailRoomId: '', // 会议详情ID
  isHandBookingSuccess: false,
};

export default state;
